import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

interface UseUnsavedChangesOptions {
  hasUnsavedChanges: boolean;
  message?: string;
}

export function useUnsavedChanges({ hasUnsavedChanges, message = 'You have unsaved changes. Are you sure you want to leave?' }: UseUnsavedChangesOptions) {
  const navigate = useNavigate();
  const hasUnsavedChangesRef = useRef(hasUnsavedChanges);

  useEffect(() => {
    hasUnsavedChangesRef.current = hasUnsavedChanges;
  }, [hasUnsavedChanges]);

  useEffect(() => {
    const handleBeforeUnload = (e: BeforeUnloadEvent) => {
      if (hasUnsavedChangesRef.current) {
        e.preventDefault();
        e.returnValue = message;
        return message;
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [message]);

  const handleNavigation = (targetPath: string) => {
    if (hasUnsavedChangesRef.current) {
      if (confirm(message)) {
        navigate(targetPath);
      }
    } else {
      navigate(targetPath);
    }
  };

  return { handleNavigation };
}
